import React from 'react';

import {
  BannerWarning,
  LocaleSelection,
  ServiceCardButton,
  HomeCustomisation,
} from '@fingermarkglobal/cringer.components';

import DineInImage from '../../../assets/images/old/dinein.svg';
import TakeawayImage from '../../../assets/images/old/takeaway.svg';
import WashHandsImage from '../../../assets/images/wash-hands.png';
import DefaultBackgroundImage from '../../../assets/images/background.png';

const PrimaryHome = ({
  t = () => {},
  healthMsg = true,
  languages = [],
  className = '',
  primaryAction,
  secondaryAction,
  onChangeLanguage = () => {},
  accessibilityEnabled = false,
  showTermsAndConditionsButton = false,
  setShowTermsAndConditionsModal = () => {},
}) => {
  return (
    <HomeCustomisation.Provider
      fallback={{
        background: {
          image: DefaultBackgroundImage,
        },
      }}
    >
      <HomeCustomisation.Background />

      <div
        data-test="primary-home"
        className={`z-10 flex flex-col justify-between items-center h-full w-full overflow-y-hidden  ${className}`}
      >
        <div
          data-test="home-lower"
          className="flex flex-col-reverse items-center justify-start w-full h-full"
        >
          <div
            data-test="home-footer"
            className={`flex justify-center mt-8 w-full ${accessibilityEnabled ? 'h-20' : ''}`}
          >
            <LocaleSelection languages={languages} onChangeLanguage={onChangeLanguage} />
          </div>

          {showTermsAndConditionsButton && (
            <BannerWarning
              t={t}
              width="109"
              data-test="banner-terms"
              className={`w-4/5 mb-${healthMsg ? '2' : '48'}`}
              title={t('homeTermsAndConditionsBannerWarningTitle')}
              description={t('homeTermsAndConditionsBannerWarningDescription')}
              additionalDescription={t('homeTermsAndConditionsBannerWarningAdditionalDescription')}
              additionalDescriptionAction={() => setShowTermsAndConditionsModal(true)}
            />
          )}

          {healthMsg && (
            <BannerWarning
              t={t}
              width="109"
              data-test="banner-health"
              image={WashHandsImage}
              className={`w-4/5 mb-${showTermsAndConditionsButton ? '2' : '48'}`}
            />
          )}

          <div
            data-test="home-services"
            className={`flex items-stretch justify-center w-4/5 ${
              healthMsg ? 'mb-32' : 'mb-52'
            } space-x-16`}
          >
            {!!secondaryAction ? (
              <ServiceCardButton
                data-test="button-secondary"
                className="w-1/2 bg-white shadow-lg rounded-home-button"
                onClick={secondaryAction}
              >
                <div className="mt-4">{t('homeSecondaryAction')}</div>
                <DineInImage className="w-64" />
              </ServiceCardButton>
            ) : null}

            {!!primaryAction ? (
              <ServiceCardButton
                data-test="button-primary"
                className="w-1/2 bg-white shadow-lg rounded-home-button"
                onClick={primaryAction}
              >
                <div className="mt-4">{t('homePrimaryAction')}</div>
                <TakeawayImage className="w-32" />
              </ServiceCardButton>
            ) : null}
          </div>
        </div>
      </div>
    </HomeCustomisation.Provider>
  );
};

export { PrimaryHome };
